(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4969],{

/***/ 31087:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/set-geofence",
      function () {
        return __webpack_require__(66810);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 66810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(29061);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(91346);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95629);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19630);
/* harmony import */ var src_components_Message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29143);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(61906);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34745);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26771);
















// 节流函数
function throttle(fn) {
    let delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1000;
    var timer;
    return function() {
        var _this = this;
        var args = arguments;
        if (timer) {
            return;
        }
        timer = setTimeout(function() {
            fn.apply(_this, args);
            timer = null // 在delay后执行完fn之后清空timer，此时timer为假，throttle触发可以进入计时器
            ;
        }, delay);
    };
}
const SetGeofence = ()=>{
    var ref, ref1, ref2, ref3;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const max = 1000;
    const { query  } = router;
    const skipDeviceInitRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(true);
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_7__/* .useTranslation */ .$G)("common");
    const [el, updateEl] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [name, updateName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    var _radius;
    const [radius, updateRadius] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(Number((_radius = query.radius) !== null && _radius !== void 0 ? _radius : 50));
    const [circle, updateCircle] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    var ref4;
    const [point, updatePoint] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref4 = (ref1 = query === null || query === void 0 ? void 0 : (ref = query.latlng) === null || ref === void 0 ? void 0 : ref.split(",")) === null || ref1 === void 0 ? void 0 : ref1.map((v)=>Number(v))) !== null && ref4 !== void 0 ? ref4 : []);
    var ref5;
    const [position, updatePosition] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref5 = query === null || query === void 0 ? void 0 : query.name) !== null && ref5 !== void 0 ? ref5 : "");
    const [showAlert, updateShowAlert] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [alertEmail, updateAlertEmail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!!(query === null || query === void 0 ? void 0 : query.email_notification));
    const [saveDisabled, toggleSaveDisabled] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [startTime, updateStartTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [endTime, updateEndTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [saveStatus, updateSaveStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [nameStatus, updateNameStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [timeStatus, updateTimeStatus] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    var ref6;
    const [week, updateWeek] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref6 = (ref3 = query === null || query === void 0 ? void 0 : (ref2 = query.week) === null || ref2 === void 0 ? void 0 : ref2.split(",")) === null || ref3 === void 0 ? void 0 : ref3.map(Number)) !== null && ref6 !== void 0 ? ref6 : []);
    const [timeData, updateTimeData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        start: "",
        end: "",
        repeat: []
    });
    const weekList = [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
    ].map((v, i)=>({
            label: "Every ".concat(v),
            value: i + 1
        }));
    /**
   * 将小于 10 的数字前加 0
   * @param { number } num 需要加 0 的数字
   * @returns 转换为字符串的数字
   */ const addZero = (num)=>(num < 10 ? "0" : "") + num;
    /**
   * 更改开始时间
   * @param { dayjs } time dayjs 类型的开始时间
   * @param { string } str hh:mm:ss 格式的字符串类型的开始时间
   */ const changeStartTime = (time, str)=>{
        updateStartTime(time);
        timeData.start = str;
        updateTimeData(timeData);
        validTimeData();
    };
    /**
   * 更改结束时间
   * @param { dayjs } time dayjs 类型的结束时间
   * @param { string } str hh:mm:ss 格式的字符串类型的结束时间
   */ const changeEndTime = (time, str)=>{
        updateEndTime(time);
        timeData.end = str;
        updateTimeData(timeData);
        validTimeData();
    };
    /**
   * 选择重复的星期几
   * @param { number[] } weekList 重复的星期列表
   */ const changeWeek = (weekList)=>{
        updateWeek(weekList);
        timeData.repeat = weekList;
        updateTimeData(timeData);
        validTimeData();
    };
    /**
   * 校验时间数据
   */ const validTimeData = ()=>{
        toggleSaveDisabled(!(timeData.start && timeData.end && timeData.repeat.length));
    };
    /**
   * 保存时间
   */ const saveTime = ()=>{
        if (saveDisabled) return;
        updateSaveStatus(true);
        updateShowAlert(false);
    };
    /**
   * 取消时间框
   */ const cancelTime = ()=>{
        updateSaveStatus(timeData.end && timeData.start && timeData.repeat.length);
        updateShowAlert(false);
    };
    /**
   * 取消设置 Geofence 并返回 geofence 列表页
   */ const cancelGeofence = ()=>{
        router.push("/android/local/geofence");
    };
    /**
   * 保存 Geofence 数据
   */ const saveGeofence = throttle(()=>{
        updateNameStatus(false);
        updateTimeStatus(false);
        if (!name.length || !point.length || point == "0") return;
        // if (!saveStatus) return updateTimeStatus(true)
        const data = {
            device_id: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readLocalDeviceUdid */ .S)(),
            name: name,
            position: position,
            radius: radius,
            // start_time: `${addZero(startTime.$H)}:${addZero(startTime.$M)}`,
            // end_time: `${addZero(endTime.$H)}:${addZero(endTime.$M)}`,
            latlng: point.join(","),
            // week: week.join(','),
            email_notification: select1Key == 0 ? false : true,
            status: select2Key == 0 ? false : true
        };
        if (query.id) {
            data.id = query.id;
            (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_2__/* .updateGenofenceInfo */ .HD)(data).then((param)=>{
                let { code , msg  } = param;
                if (code) (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(msg, 1);
                else cancelGeofence();
            });
        } else {
            (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_2__/* .createGeofenceInfo */ .xT)(data).then((param)=>{
                let { code , msg , data: result  } = param;
                // 通知app数据更改
                (0,src_api_android__WEBPACK_IMPORTED_MODULE_5__/* .androidLocalRefresh */ .DF)({
                    device_id: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_12__/* .readLocalDeviceUdid */ .S)(),
                    type: "41",
                    geofence: [
                        {
                            ...data,
                            id: result.id
                        }
                    ]
                });
                if (code) (0,src_components_Message__WEBPACK_IMPORTED_MODULE_6__/* .messageInfo */ .B)(msg, 1);
                else cancelGeofence();
            });
        }
    }, 3000);
    /**
   * 获取当前坐标点
   * @returns { Promise<[number, number]> } 一个包含有当前经纬度的数组
   */ const getPoint = async ()=>{
        if ((point === null || point === void 0 ? void 0 : point.length) === 2) {
            return point;
        }
        // IP 定位
        return await getPointByIP();
    };
    const getPointByIP = async ()=>{
        try {
            const res = await fetch("https://ipapi.co/json/");
            const data = await res.json();
            ;
            if (data.latitude && data.longitude) {
                return [
                    data.latitude,
                    data.longitude
                ];
            }
        } catch (e) {
            ;
        }
        // 最终兜底（避免地图炸）
        return [
            0,
            0
        ];
    };
    /**
   * 获取当前位置信息
   * @param { number } latitude 纬度
   * @param { number } longitude 经度
   * @returns { Object } 地理位置信息
   */ const getPosition = async function() {
        let latitude = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, longitude = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        return new Promise((success, fail)=>{
            axios__WEBPACK_IMPORTED_MODULE_13__/* ["default"].get */ .Z.get("".concat("https://api.bigdatacloud.net/data/reverse-geocode-client", "?latitude=").concat(latitude, "&longitude=").concat(longitude)).then((res)=>res.data).then((res)=>res ? success(res) : fail(res));
        });
    };
    /**
   * 更改半径
   * @param { number } radius 半径
   */ const changeRadius = (radius)=>{
        if (circle) circle.setRadius(radius).redraw();
        updateRadius(radius);
    };
    /**
   * 更改定位位置
   * @todo 根据用户输入的地址转换对应经纬度并定位到该地点
   */ const changePosition = ()=>{};
    // 修改name写入input
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        var _name;
        updateName((_name = query.name) !== null && _name !== void 0 ? _name : "");
    }, []);
    // 设备切换时重置围栏编辑表单并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_11__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (skipDeviceInitRef.current) {
            skipDeviceInitRef.current = false;
            return;
        }
        if (query.id) {
            router.push("/android/local/geofence");
        }
    }, [
        query.id,
        router
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // el 为地图容器元素 存在代表着地图已初始化
        if (el) return;
        else getPoint().then((point)=>getPosition(...point).then((res)=>updatePosition(res.localityInfo.administrative.map((v)=>v.name.replaceAll(" ", "")).reverse().join(" "))).then((res)=>point)).then((point)=>{
            updatePoint(point);
            ;
            // import('L').then(L => {
            const el = document.getElementById("map");
            const map = L.map(el, {
                maxZoom: 20,
                minZoom: 1
            }).setView(point, 17);
            // 设置地图
            L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(map);
            // 范围圆圈
            const circle = L.circle(point, {
                color: "skyblue",
                fillColor: "skyblue",
                fillOpacity: ".5",
                radius: radius
            }).addTo(map);
            // 标记点
            L.marker(point, {
                draggable: true
            }).on("move", (e)=>{
                point[0] = e.latlng.lat;
                point[1] = e.latlng.lng;
                circle.setLatLng(e.latlng).redraw();
                updatePoint(point);
            }).on("dragend", async (e)=>{
                ;
                const res = await getPosition(...point);
                updatePosition(res.localityInfo.administrative.map((v)=>v.name.replaceAll(" ", "")).reverse().join(" "));
            }).addTo(map);
            updateEl(el);
            updateCircle(circle);
        // })
        });
    }, []);
    const select1Data = {
        0: "Never notify",
        1: 'Only "Enters zone"'
    };
    const select2Data = {
        0: "Restricted",
        1: "Allowed"
    };
    const [select1Open, setSelect1Open] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [select2Open, setSelect2Open] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [select1Key, setSelect1Key] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((query === null || query === void 0 ? void 0 : query.email_notification) == "true" ? 1 : 0);
    const [select2Key, setSelect2Key] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((query === null || query === void 0 ? void 0 : query.status) == "true" ? 1 : 0);
    const [sliderValue, setSliderValue] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(t("Geofence")));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_10__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-full overflow-auto Blds:relative Blds:drop-shadow-none",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full pt-[15px] pb-[30px] px-[15px] Blds:w-[375px] Blds:absolute Blds:top-[12px] Blds:left-[16px] Blds:z-[999] Blds:bg-[#FFF] Blds:rounded-[10px] Blds:drop-shadow-[0_0_12px_rgba(0,0,0,0.13)]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[16px] text-[#11141A] font-[600]",
                            children: t("Add new fence zone")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-[13px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[13px] text-[#222222] Blds:text-[14px]",
                                    children: [
                                        "1. ",
                                        t("Tap on the map to add new fence zone")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-[1px] text-[12px] text-[#8F98AF]",
                                    children: t("Intersections of fences are not allowed")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-[13px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-[13px] text-[#222222] Blds:text-[14px]",
                                            children: [
                                                "2. ",
                                                t("Radius")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "text-[13px] text-[#222222]",
                                            children: [
                                                radius,
                                                " m"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
                                    "aria-label": "Temperature",
                                    value: radius,
                                    onChange: (_, newValue)=>changeRadius(newValue),
                                    valueLabelDisplay: "auto",
                                    step: 20,
                                    marks: true,
                                    min: 50,
                                    max: max
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-[11px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[13px] text-[#222222] Blds:text-[14px]",
                                    children: [
                                        "3. ",
                                        t("Geo-fence name")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                    className: "mt-[18px] w-full h-[34px] px-[15px] rounded-[30px] bg-[#F4F5F6] outline-none text-[13px] text-[#222222]",
                                    value: name,
                                    onChange: (e)=>updateName(e.target.value.trim())
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mt-[3px] text-[12px] text-[#8F98AF]",
                                    children: t("Geofence name must not be less than 3 and greater than 32 characters")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-[28px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[13px] text-[#222222] Blds:text-[14px]",
                                    children: [
                                        "4. ",
                                        t("Notification")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-[18px] w-full h-[34px] pl-[15px] pr-[13px] rounded-[30px] bg-[#F4F5F6] text-[13px] text-[#222222] flex justify-between items-center relative cursor-pointer",
                                    onClick: ()=>setSelect1Open((val)=>!val),
                                    children: [
                                        select1Data[select1Key],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                            src: "/images/geofence/drop-down.svg",
                                            width: 15,
                                            height: 16,
                                            alt: "dorp-down"
                                        }),
                                        select1Open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full bg-[#FFF] rounded-[8px] shadow-[0_0_8px_rgba(0,0,0,0.15)] absolute top-[34px] left-0 overflow-hidden z-50",
                                            children: Object.keys(select1Data).map((key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(select1Key == key ? "bg-[#F5F5F5]" : "", " w-full h-[45px] pl-[18px] flex items-center"),
                                                    onClick: ()=>setSelect1Key(key),
                                                    children: select1Data[key]
                                                }, key))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full mt-[28px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-[13px] text-[#222222] Blds:text-[14px]",
                                    children: [
                                        "5. ",
                                        t("Geo-fence type")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-[18px] w-full h-[34px] pl-[15px] pr-[13px] rounded-[30px] bg-[#F4F5F6] text-[13px] text-[#222222] flex justify-between items-center relative cursor-pointer",
                                    onClick: ()=>setSelect2Open((val)=>!val),
                                    children: [
                                        select2Data[select2Key],
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                                            src: "/images/geofence/drop-down.svg",
                                            width: 15,
                                            height: 16,
                                            alt: "dorp-down"
                                        }),
                                        select2Open && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-full bg-[#FFF] rounded-[8px] shadow-[0_0_8px_rgba(0,0,0,0.15)] absolute top-[34px] left-0 overflow-hidden z-50",
                                            children: Object.keys(select2Data).map((key)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "".concat(select2Key == key ? "bg-[#F5F5F5]" : "", " w-full h-[45px] pl-[18px] flex items-center"),
                                                    onClick: ()=>setSelect2Key(key),
                                                    children: select2Data[key]
                                                }, key))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mt-[40px] w-full h-[34px] flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex-1 border border-[#454CFF] rounded-[17px] text-[16px] text-[#454CFF] font-[600] flex justify-center items-center cursor-pointer",
                                    onClick: cancelGeofence,
                                    children: t("Cancel")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[8px] h-full"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "".concat(!name.length || !point.length || point == "0" ? "opacity-70 cursor-not-allowed" : "cursor-pointer", " flex-1 bg-[#FFCF55] rounded-[17px] text-[16px] text-[#1B1C2B] font-[600] flex justify-center items-center"),
                                    onClick: saveGeofence,
                                    children: query.id ? t("Save zone") : t("Add zone")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full h-[500px] overflow-hidden Blds:h-[calc(var(--vh)*100-90px)]",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "map",
                        className: "w-full h-full"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (SetGeofence);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,1346,9774,2888,179], function() { return __webpack_exec__(31087); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);